import EstimatesPage from './components/Estimates.page';
import SingleEstimatesPage from './components/SingleEstimate.page.js';

export { EstimatesPage, SingleEstimatesPage };
